// 全局配置
export default {
    version: '0.1',
    upMinuteTime: 60000, // 分时图更新间隔 30秒
    upKlineTime: 60000, // K线一分钟更新一次
    upDpTime: 3000, // 大盘更新间隔 3秒
    upFooterTime: 6000, // 底部持仓等信息，6秒更新一次
    cancelOrderTime: 2000, // 撤单刷新时间
    // 持仓字段 有些字段，后边的true，是需要变大的表格，如时间和编号，比较长的
    strategyTag: [
        ['股票代码', 'stock_code',],
        ['股票名称', 'stock_name'],
        ['总持仓数', 'stock_number'],
        ['可卖数量', 'cansell_number'],
        ['冻结数量', 'notcansell_number'],
        ['成交均价', 'average_price'],
        ['当前价', 'now_price'],
        ['参考盈亏', 'getprice'],
        ['持仓市值', 'now_market_value'],
        ['盈亏比例(%)', 'profit_ratio']
    ],
    // 委托字段
    chedanstrategyTag: [
        ['委托编号', 'strategy_num', true],
        ['委托时间', 'time', true],
        ['最后更新时间', 'update_time', true],
        ['股票代码', 'stock_code'],
        ['股票名称', 'stock_name'],
        ['委托方向', 'cancel_type'],
        ['委托价格', 'price'],
        ['委托数量', 'stock_number'],
        ['成交数量', 'chengjiao_num'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['撤单数量', 'chedan_num'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['订单冻结总金额', 'dongjie_money'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['下单类型', 'type'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['委托状态', 'msg'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['操作', 'cancel_ctrl']
    ],
    // 委托日志字段
    chedanstrategyLogTag: [
        ['委托编号', 'strategy_num', true],
        ['委托时间', 'time', true], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['最后更新时间', 'update_time', true], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['股票代码', 'stock_code'],
        ['股票名称', 'stock_name'],
        ['委托方向', 'cancel_type'],
        ['委托价格', 'price'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['委托数量', 'stock_number'],
        ['成交数量', 'chengjiao_num'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['撤单数量', 'chedan_num'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['订单冻结总金额', 'dongjie_money'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['委托状态', 'status'],
        ['备注', 'g', true] // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
    ],
    // 历史记录字段
    historyTag: [
        ['成交编号', 'strategy_num', true],
        ['成交时间', 'create_time', true],
        ['股票代码', 'stock_code'],
        ['股票名称', 'stock_name'],
        ['交易方向', 'strategy_type'],
        ['成交数量', 'stock_number'],
        ['成交价格', 'price'],
        ['成交金额', 'total'],
        ['佣金', 'poundage'],
        ['印花税', 'yinhua_money'],
        ['过户费', 'guhu'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['信息撮合费', 'cuohe'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['明细', 'mingxi'] // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        // ['市值盈亏', 'getprice'],
        // ['现价', 'now_price']
    ],
    // 资产字段
    accountinfoTag: [
        ['账户名', 'accont'],
        ['保证金', 'baozhengjin'],
        ['配资金额', 'peizijine'],
        ['自有资产', 'ziyou_money'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['总资产', 'all_money'],
        ['浮动盈亏', 'nowyingkui'],
        ['持仓市值', 'chicangshizhi'],
        ['开仓成本', 'kaicang_money'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['冻结资金', 'mairudongjie'],
        ['可用资金', 'can_money'],
        ['可取资金', 'kequ_money'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['保证金余额', 'bzj_balance'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['配资余额', 'pz_balance'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['占用保证金', 'zy_money'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['占用配资', 'zy_pz'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['T1占用配资', 't1_zy_pz'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['冻结递延费', 'djdy_moeny'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['出入金合计', 'crj_moeny'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['累计盈亏', 'zongyingkui'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['平仓盈亏', 'pcyingkui'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['亏损比', 'ks_bl'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['预警线', 'vigilance'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['强平线', 'open_line'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['禁开线', 'jk_line'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
    ],
    // 资金流水
    zijinliushui: [
        ['用户名', 'a'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['资金变动', 'b'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['变动类型', 'c'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['变动原因', 'd', true], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['保证金余额(前)', 'e'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['保证金余额(后)', 'f'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['配资余额(前)', 'g'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['配资余额(后)', 'h'], // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        ['变动时间', 'i', true] // 没有没有没有没有没有没有没有没有没有没有没有没有没有没有没有
        // ['市值盈亏', 'getprice'],
        // ['现价', 'now_price']
    ],
    TradeHeads: [['代码', 'code'], ['名称', 'name'], ['涨幅%', 'gain'], ['最新价', 'latestPrice'],
        ['涨跌', 'gainValue'], ['买价', 'buyOnePri'], ['卖价', 'sellOnePri'],
        ['买量', 'buyOne'], ['卖量', 'sellOne'], ['总手', 'volume'],
        ['昨收', 'preClose'], ['开盘', 'open'], ['最高', 'high'], ['最低', 'low'],
        ['市盈率', 'pe'], ['市净率', 'pb'], ['总市值', 'totalMarketValue']
    ],
    dpanHeads: [
        ['代码', 'symbol'],
        ['名称', 'name'],
        ['涨幅%', 'gain_p'],
        ['最新价', 'latestPrice'],
        ['涨跌', 'gain'],
        ['成交手数', 'chenjiao'],
        ['昨收', 'yest_price'],
        ['开盘', 'open_price'],
        ['最高', 'height_price'],
        ['最低', 'low_price'],
        ['成交额', 'chenjiao_price']
    ],
    bkTags: ['指数', '沪深', '中小板', '创业板', '科创板', '自选股'],

    /**
     * 字段值替换为文字
     * @param value
     * @param tag
     * @returns {string|*}
     */
    itemValue(value, tag) {
        if (tag === 'cancel_type') {
            return +value === 1 ? '买' : '卖';
        } else if (tag === 'strategy_type') {
            return +value === 1 ? '买入' : '卖出';
        } else if (tag === 'status') {
            return +value === 1 ? '失效' : '生效';
        } else if (tag === 'sell_type') {
            return +value === 1 ? '主动卖出' : (+value === 2 ? '系统卖出' : '');
        } else if (tag === 'profit_ratio') {
            return +value + '%';
        } else {
            return value;
        }
    },
}
